import React from 'react'

/**
 * @typedef {{
 *   currentId: number,
 *   videoDuration: number,
 *   pause: boolean,
 *   next: () => void,
 *   count?: number,
 *   setCount?: React.Dispatch<React.SetStateAction<number>>,
 *   bufferAction?: boolean,
 *   setVideoDuration?: (duration: number) => void,
 *   setPause?: (pause: boolean) => void,
 *   previous?: () => void,
 *   toggleState?: (state: string, source?: string) => void,
 *   setCurrentId?: (val: number | ((prev: number) => number)) => void,
 *   playbackCommand?: { action: string, source: string, sequence: number },
 *   progressMode?: 'timer' | 'media',
 *   setProgressMode?: (mode: 'timer' | 'media') => void,
 *   storyCycle?: number,
 * }} ProgressContextValue
 */

export default React.createContext(
    /** @type {ProgressContextValue} */ ({
        currentId: 0,
        videoDuration: 0,
        pause: false,
        next: () => {},
    }),
)
